import {
    VERIFY_PAYORDER_SUCCESS,
    VERIFY_PAYORDER_FAILED,
    VERIFY_PAYORDER_INVALID_REQUEST,
    VERIFY_PAYORDER_INVALID_CUSTOMER_ID,
    VERIFY_PAYORDER_INVALID_WALLET_OWNER_ID,
    VERIFY_PAYORDER_INVALID_AMOUNT,
    VERIFY_PAYORDER_ACCOUNT_NOT_EXISTS,
    VERIFY_PAYORDER_INSUFFICIENT_AMOUNT,
    VERIFY_PAYORDER_INVALID_INTEGRATION,
    VERIFY_PAYORDER_INVALID_TELCC,
    VERIFY_PAYORDER_INVALID_PHONE,
    VERIFY_PAYORDER_INVALID_NAME,
    VERIFY_PAYORDER_INVALID_OTP,
    LOADING_VERIFY_PAYORDER,
    RESET_VERIFY_PAYORDER
} from "../types";

const initialState = {
    isLoading: false,
    success: false,
    failed: false,
    invalidRequest: false,
    invalidOTP: false,
    insufficientAmount: false,
    accountNotExists: false,
    invalidName: false,
    invalidWalletOwnerId: false,
    invalidPhone: false,
    invalidCustomerID: false,
    invalidAmount: false,
    invalidIntegration: false,
    invalidTelcc: false,
    data: {},
    status: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_VERIFY_PAYORDER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                invalidRequest: false,
                invalidOTP: false,
                insufficientAmount: false,
                accountNotExists: false,
                invalidName: false,
                invalidWalletOwnerId: false,
                invalidPhone: false,
                invalidCustomerID: false,
                invalidAmount: false,
                invalidIntegration: false,
                invalidTelcc: false,
                data: {},
                status: ""
            };
        case VERIFY_PAYORDER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                invalidRequest: false,
                invalidOTP: false,
                insufficientAmount: false,
                accountNotExists: false,
                invalidName: false,
                invalidWalletOwnerId: false,
                invalidPhone: false,
                invalidCustomerID: false,
                invalidAmount: false,
                invalidIntegration: false,
                invalidTelcc: false,
                data: action.payload,
                status: ""
            };
        case VERIFY_PAYORDER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                invalidRequest: false,
                invalidOTP: false,
                insufficientAmount: false,
                accountNotExists: false,
                invalidName: false,
                invalidWalletOwnerId: false,
                invalidPhone: false,
                invalidCustomerID: false,
                invalidAmount: false,
                invalidIntegration: false,
                invalidTelcc: false,
                data: action.payload,
                status: "Pay Order Verification Failed."
            };
        case VERIFY_PAYORDER_INVALID_REQUEST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                invalidRequest: true,
                invalidOTP: false,
                insufficientAmount: false,
                accountNotExists: false,
                invalidName: false,
                invalidWalletOwnerId: false,
                invalidPhone: false,
                invalidCustomerID: false,
                invalidAmount: false,
                invalidIntegration: false,
                invalidTelcc: false,
                data: action.payload,
                status: "Invalid Verification Request."
            };
        case VERIFY_PAYORDER_INVALID_CUSTOMER_ID:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                invalidRequest: false,
                invalidOTP: false,
                insufficientAmount: false,
                accountNotExists: false,
                invalidName: false,
                invalidWalletOwnerId: false,
                invalidPhone: false,
                invalidCustomerID: true,
                invalidAmount: false,
                invalidIntegration: false,
                invalidTelcc: false,
                data: action.payload,
                status: "Invalid Customer ID."
            };
        case VERIFY_PAYORDER_INVALID_WALLET_OWNER_ID:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                invalidRequest: false,
                invalidOTP: false,
                insufficientAmount: false,
                accountNotExists: false,
                invalidName: false,
                invalidWalletOwnerId: true,
                invalidPhone: false,
                invalidCustomerID: false,
                invalidAmount: false,
                invalidIntegration: false,
                invalidTelcc: false,
                data: action.payload,
                status: "Invalid Wallet Owner Id."
            };
        case VERIFY_PAYORDER_INVALID_AMOUNT:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                invalidRequest: false,
                invalidOTP: false,
                insufficientAmount: false,
                accountNotExists: false,
                invalidName: false,
                invalidWalletOwnerId: false,
                invalidPhone: false,
                invalidCustomerID: false,
                invalidAmount: true,
                invalidIntegration: false,
                invalidTelcc: false,
                data: action.payload,
                status: "Invalid Amount."
            };
        case VERIFY_PAYORDER_INSUFFICIENT_AMOUNT:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                invalidRequest: false,
                invalidOTP: false,
                insufficientAmount: true,
                accountNotExists: false,
                invalidName: false,
                invalidWalletOwnerId: false,
                invalidPhone: false,
                invalidCustomerID: false,
                invalidAmount: false,
                invalidIntegration: false,
                invalidTelcc: false,
                data: action.payload,
                status: "Insufficient Amount."
            };
        case VERIFY_PAYORDER_ACCOUNT_NOT_EXISTS:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                invalidRequest: false,
                invalidOTP: false,
                insufficientAmount: false,
                accountNotExists: true,
                invalidName: false,
                invalidWalletOwnerId: false,
                invalidPhone: false,
                invalidCustomerID: false,
                invalidAmount: false,
                invalidIntegration: false,
                invalidTelcc: false,
                data: action.payload,
                status: "Account Does Not Exist."
            };
        case VERIFY_PAYORDER_INVALID_INTEGRATION:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                invalidRequest: false,
                invalidOTP: false,
                insufficientAmount: false,
                accountNotExists: false,
                invalidName: false,
                invalidWalletOwnerId: false,
                invalidPhone: false,
                invalidCustomerID: false,
                invalidAmount: false,
                invalidIntegration: true,
                invalidTelcc: false,
                data: action.payload,
                status: "Invalid Integration."
            };
        case VERIFY_PAYORDER_INVALID_TELCC:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                invalidRequest: false,
                invalidOTP: false,
                insufficientAmount: false,
                accountNotExists: false,
                invalidName: false,
                invalidWalletOwnerId: false,
                invalidPhone: false,
                invalidCustomerID: false,
                invalidAmount: false,
                invalidIntegration: false,
                invalidTelcc: true,
                data: action.payload,
                status: "Invalid Country Code."
            };
        case VERIFY_PAYORDER_INVALID_PHONE:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                invalidRequest: false,
                invalidOTP: false,
                insufficientAmount: false,
                accountNotExists: false,
                invalidName: false,
                invalidWalletOwnerId: false,
                invalidPhone: true,
                invalidCustomerID: false,
                invalidAmount: false,
                invalidIntegration: false,
                invalidTelcc: false,
                data: action.payload,
                status: "Invalid Phone Number."
            };
        case VERIFY_PAYORDER_INVALID_NAME:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                invalidRequest: false,
                invalidOTP: false,
                insufficientAmount: false,
                accountNotExists: false,
                invalidName: true,
                invalidWalletOwnerId: false,
                invalidPhone: false,
                invalidCustomerID: false,
                invalidAmount: false,
                invalidIntegration: false,
                invalidTelcc: false,
                data: action.payload,
                status: "Invalid Name."
            };
        case VERIFY_PAYORDER_INVALID_OTP:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                invalidRequest: false,
                invalidOTP: true,
                insufficientAmount: false,
                accountNotExists: false,
                invalidName: false,
                invalidWalletOwnerId: false,
                invalidPhone: false,
                invalidCustomerID: false,
                invalidAmount: false,
                invalidIntegration: false,
                invalidTelcc: false,
                data: action.payload,
                status: ""
            };
        case RESET_VERIFY_PAYORDER:
            return (state = initialState);

        default:
            return state;
    }
};


